export default {
  CHAT_POPUP: "ChatPopup",
  CONFIRM_POPUP: "ConfirmPopup",
  DEMO_REQUEST_POPUP: "DemoRequestPopup",
};
